import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Map from "./Map";
import Locations from "./Locations";
import axiosInstance from "../../../../axiosInstance";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import SearchResidences from "./SearchResidences";
import ResidencesContext from "../../../../contexts/Residences/ResidencesContext";
import Swal from "sweetalert2";
import { getTheme } from "../../../../styles/theme";
import { useTranslation } from "react-i18next";

export default function Residences({ open, setOpen, isMobile, setIsMobile }) {
  const {
    locations,
    setLocations,
    nearByUniversities,
    setNearByUniversities,
    selectedLocation,
    universityTabControl,
    setUniversityTabControl,
    setSelectedLocation,
    setSearchedResidence,
    setSearchTerm,
    disabledControl,
    setDisabledControl,
    setPublicType,
    setSelectedLocationNearBy,
  } = useContext(ResidencesContext);
  const [loading, setLoading] = useState(false);

  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );
  const mapRef = useRef(null);
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin

  const { t } = useTranslation();

  const moveToLocation = (lng, lat, type) => {
    if (mapRef.current) {
      mapRef.current.flyTo({
        center: [lng, lat],
        essential: true,
        zoom: type ? type : 10,
      });
      // mapRef.current.once("movestart", () => {
      //   setDisabledControl(true);
      // });
      // mapRef.current.once("moveend", () => {
      //   setDisabledControl(false);
      // });
    }
  };

  const getNearByUbiversities = async (type, selectedLocation) => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    setLoading(true);
    try {
      let url;
      if (selectedLocation?.university_id && type === "near_residences") {
        url = `near_residences?university_id=${selectedLocation?.university_id}`;
      } else {
        url = `near_universities?campus_id=${selectedLocation?.campus_id}`;
      }

      if (selectedLocation?.campus_id && type === "near_universities") {
        url = `near_universities?campus_id=${selectedLocation?.campus_id}`;
      } else {
        url = `near_residences?university_id=${selectedLocation?.university_id}`;
      }
      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
          XRefreshToken: `${token}`, // Bearer token burada ekleniyor,
          Accounts: selectedBranchesString,
          "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
        },
      });
      if (type === "near_universities") {
        setPublicType(null);
        setNearByUniversities(response.data.universities);
      } else {
        setPublicType(null);
        setNearByUniversities(response.data.residences);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error sending data:", error.response);
    }
  };

  const getLocations = async (type) => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${type === "residence" ? `dashboard/residences` : `universities`}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
            XRefreshToken: `${token}`, // Bearer token burada ekleniyor,
            Accounts: selectedBranchesString,
            "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
          },
        }
      );
      if (type === "residence") {
        setLocations(response.data);
      } else {
        setNearByUniversities(null);
        setSelectedLocation(null);
        setLocations(response.data?.universities);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error sending data:", error.response);
    }
  };

  // useEffect(() => {
  //   getLocations("residence");
  // }, [selectedBranchesString]);

  useEffect(() => {
    setSearchedResidence("");
    setSearchTerm("");
    setNearByUniversities(null);
    setSelectedLocation(null);
    // moveToLocation(-0.1278, 51.5074, 32);
    if (universityTabControl) {
      getLocations("university");
      setNearestPlaceType("residences");
    } else {
      getLocations("residence");
      setNearestPlaceType("universities");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [universityTabControl]);

  useEffect(() => {
    if (selectedLocation !== "" && !selectedLocation?.nearControl) {
      if (universityTabControl) {
        getNearByUbiversities("near_residences", selectedLocation);
      } else {
        getNearByUbiversities("near_universities", selectedLocation);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocation]);

  const mapComponent = useMemo(() => {
    if (locations?.length) {
      return (
        <>
          <Grid item xs={12} lg={8} sx={{ position: "relative" }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxHeight: "500px",
                pr: { xs: 3, lg: 0 },
                height: "100%",
                paddingLeft: "24px",
                paddingBottom: "24px",
                // padding: "1rem",
                // background: lightMode ? "#ffffff" : "#292929",
                position: "relative",
              }}
            >
              {loading ? (
                <Box sx={{ height: "500px", width: "100%" }}>
                  <Skeleton
                    width={"100%"}
                    height={"100%"}
                    sx={{ transform: "scale(1,1)", borderRadius: "1rem" }}
                  />
                </Box>
              ) : (
                <>
                  <Map
                    mapRef={mapRef}
                    open={open}
                    setOpen={setOpen}
                    isMobile={isMobile}
                    setIsMobile={setIsMobile}
                  />
                  <SearchResidences
                    mapRef={mapRef}
                    moveToLocation={moveToLocation}
                  />
                </>
              )}
            </Box>
          </Grid>
        </>
      );
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations, open]);

  const titleRef = useRef();

  const getNearestLocations = async (type) => {
    setSelectedLocationNearBy(null);
    let locationBox;
    if (universityTabControl) {
      locationBox = `${parseFloat(selectedLocation?.university_latitude) - 0.01
        }, ${parseFloat(selectedLocation?.university_longitude) - 0.01}, ${parseFloat(selectedLocation?.university_latitude) + 0.01
        }, ${parseFloat(selectedLocation?.university_longitude) + 0.01}  `;
    } else {
      locationBox = `${parseFloat(selectedLocation?.campus_coordinates?.lat) - 0.01
        }, ${parseFloat(selectedLocation?.campus_coordinates?.lng) - 0.01}, ${parseFloat(selectedLocation?.campus_coordinates?.lat) + 0.01
        }, ${parseFloat(selectedLocation?.campus_coordinates?.lng) + 0.01}  `;
    }

    let url;
    if (type === "bus") {
      url = `
      https://overpass-api.de/api/interpreter?data=[out:json];node["highway"="bus_stop"](${locationBox});out body;
      `;
    } else if (type === "train") {
      url = `
      https://overpass-api.de/api/interpreter?data=[out:json];node["railway"="station"](${locationBox});out body;
      `;
    } else if (type === "market") {
      url = `
      https://overpass-api.de/api/interpreter?data=[out:json];node["shop"="supermarket"](${locationBox});out body;
      `;
    } else if (type === "pharmacie") {
      url = `
      https://overpass-api.de/api/interpreter?data=[out:json];node["amenity"="pharmacy"](${locationBox});out body;
      `;
    } else if (type === "restaurant") {
      url = `
        https://overpass-api.de/api/interpreter?data=[out:json];node["amenity"="restaurant"](${locationBox});out body;
        `;
    }

    try {
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
        },
      });
      if (type === "bus") {
        setPublicType("bus");
      } else if (type === "train") {
        setPublicType("train");
      } else if (type === "market") {
        setPublicType("market");
      } else if (type === "pharmacie") {
        setPublicType("pharmacie");
      } else if (type === "restaurant") {
        setPublicType("restaurant");
      }
      if (!response?.data?.elements?.length) {
        setPublicType(null);
        Swal.fire({
          icon: "error",
          title: `No ${type === "bus"
            ? `${t("busStations")}`
            : type === "train"
              ? `${t("trainStations")}`
              : type === "market"
                ? `${t("supermarkets")}`
                : type === "pharmacie"
                  ? `${t("pharmacies")}`
                  : type === "restaurant"
                    ? `${t("restaurants")}`
                    : null
            } Found for ${universityTabControl
              ? `${selectedLocation?.university_title} `
              : `${selectedLocation?.campus_name} `
            }`,
          showConfirmButton: false,
          showCloseButton: true,
        });
      } else {
        setNearByUniversities(response?.data?.elements);
      }
    } catch (error) {
      console.error("API isteği sırasında hata oluştu:", error);
    }
  };
  useEffect(() => {
    if (nearByUniversities?.length) {
      setDisabledControl(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nearByUniversities]);

  const baseTheme = getTheme(lightMode);

  const theme = createTheme({
    ...baseTheme,
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            "&.Mui-disabled": {
              border: "none",
            },
          },
        },
      },
    },
  });

  const [nearestPlaceType, setNearestPlaceType] = React.useState(
    universityTabControl ? "residences" : "universities"
  );
  const handleChange = (event) => {
    setNearestPlaceType(event.target.value);
    if (
      event.target.value === "universities" ||
      event.target.value === "residences"
    ) {
      setSelectedLocationNearBy(null);
      getNearByUbiversities(
        universityTabControl ? "near_residences" : "near_universities",
        selectedLocation
      );
    } else if (event.target.value === "bus-stations") {
      getNearestLocations("bus");
    } else if (event.target.value === "train-stations") {
      getNearestLocations("train");
    } else if (event.target.value === "supermarkets") {
      getNearestLocations("market");
    } else if (event.target.value === "pharmacies") {
      getNearestLocations("pharmacie");
    } else if (event.target.value === "restaurants") {
      getNearestLocations("restaurant");
    }
  };

  return locations?.length ? (
    <ThemeProvider theme={theme}>
      <>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h5"
                color={lightMode ? theme.palette.customRed.orange : "#ffffff"}
                sx={{
                  fontWeight: "700",
                  mr: "auto",
                  width: "100%",
                  p: 2,
                  pb: 1,
                  textTransform: 'uppercase',
                  borderBottom: `1px dashed ${lightMode ? `#e9ecee` : `#333e47`
                    } `,
                }}
              >
                {t("residenceLocations")}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                borderBottom: `1px solid ${lightMode ? `#70707013` : `#515151`
                  }  `,
                background: lightMode ? "#F4F6F8" : "#2a323d",
                padding: "8px 16px",
                gap: 1,
              }}
            >
              <Button
                sx={{
                  border: "none",
                  fontSize: "16px",
                  background: universityTabControl ? "transparent" : "#fff",
                  boxShadow: universityTabControl
                    ? "unset"
                    : "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",

                  borderRadius: "8px",
                  minWidth: "48px",
                  padding: "8px",
                  color: universityTabControl
                    ? "#637381"
                    : theme.palette.primary.light,
                  position: "relative",
                  "&:hover": {
                    border: "none !important",
                    background: universityTabControl ? "transparent" : "#fff",
                  },
                }}
                disabled={loading || disabledControl}
                variant="outlined"
                onClick={() => {
                  setDisabledControl(true);
                  setUniversityTabControl(false);
                  setSelectedLocation(null);
                  setSelectedLocationNearBy(null);
                }}
              >
                {t("residences")}
              </Button>
              <Button
                sx={{
                  border: "none",
                  fontSize: "16px",
                  borderRadius: "8px",
                  minWidth: "48px",
                  padding: "8px",
                  background: universityTabControl ? "#fff" : "transparent",
                  boxShadow: universityTabControl
                    ? "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)"
                    : "unset",
                  color: universityTabControl
                    ? theme.palette.primary.light
                    : "#637381",
                  position: "relative",
                  "&:hover": {
                    border: "none !important",
                    background: universityTabControl ? "#fff" : "transparent",
                  },
                }}
                disabled={loading || disabledControl}
                variant="outlined"
                onClick={() => {
                  setDisabledControl(true);
                  setSelectedLocationNearBy(null);
                  setUniversityTabControl(true);
                  setSelectedLocation(null);
                }}
              >
                {t("universities")}
              </Button>
            </Box>
          </Grid>

          {mapComponent}

          <Grid
            item
            xs={12}
            lg={4}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Box
              sx={{
                maxHeight: 470,
                overflow: "hidden",
              }}
            >
              {nearByUniversities?.length ? (
                <Box
                  sx={{
                    px: { xs: "1rem", lg: 0 },
                  }}
                >
                  <Typography
                    ref={titleRef}
                    variant="h5"
                    sx={{
                      textTransform: 'capitalize',
                      marginBottom: "1rem",
                    }}
                  >
                    {t("nearestPlacesFor")}{" "}
                    <Typography>
                      {universityTabControl
                        ? `${selectedLocation?.university_title} `
                        : `${selectedLocation?.campus_name} `}
                    </Typography>
                  </Typography>

                  {nearestPlaceType ? (
                    <Box sx={{ minWidth: 120, marginBottom: "1rem" }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          {t("nearestPlaceType")}
                        </InputLabel>
                        <Select
                          sx={{ textTransform: 'capitalize' }}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          // value={nearestPlaceType}
                          value={
                            nearestPlaceType ||
                            (universityTabControl
                              ? "residences"
                              : "universities")
                          }
                          label={t("nearestPlaceType")}
                          onChange={handleChange}
                        >
                          <MenuItem
                            sx={{
                              textTransform: 'capitalize',
                              display: universityTabControl ? "block" : "none",
                            }}
                            value={"residences"}
                          >
                            {t("residences")}
                          </MenuItem>
                          <MenuItem
                            sx={{
                              textTransform: 'capitalize',
                              display: universityTabControl ? "none" : "block",
                            }}
                            value={"universities"}
                          >
                            {t("universities")}
                          </MenuItem>
                          <MenuItem sx={{ textTransform: 'capitalize' }} value={"bus-stations"}>
                            {t("busStations")}
                          </MenuItem>
                          <MenuItem sx={{ textTransform: 'capitalize' }} value={"train-stations"}>
                            {t("trainStations")}
                          </MenuItem>
                          <MenuItem sx={{ textTransform: 'capitalize' }} value={"supermarkets"}>
                            {t("supermarkets")}
                          </MenuItem>
                          <MenuItem sx={{ textTransform: 'capitalize' }} value={"pharmacies"}>{t("pharmacies")}</MenuItem>
                          <MenuItem sx={{ textTransform: 'capitalize' }} value={"restaurants"}>{t("restaurants")}</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  ) : null}

                  {/* <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    borderBottom: "1px solid #efefef",
                    marginBottom: "1rem",
                    overflowX: "auto",
                    height: "50px",
                  }}
                >
                  <Button
                    sx={{
                      minWidth: "max-content",
                      "&:before": {
                        content: '""',
                        borderTopRightRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        height: "2px",
                        background: "#23416c",
                        display: publicType === null ? "block" : "none",
                      },
                      color:
                        nearByUniversities?.length && publicType === null
                          ? "#23416c"
                          : "#000000",
                    }}
                    onClick={() => {
                      setSelectedLocationNearBy(null);
                      getNearByUbiversities(
                        universityTabControl
                          ? "near_residences"
                          : "near_universities",
                        selectedLocation
                      );
                    }}
                  >
                    {universityTabControl ? `Residences` : `Universities`}
                  </Button>

                  <Button
                    sx={{
                      minWidth: "max-content",
                      "&:before": {
                        content: '""',
                        borderTopRightRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        height: "2px",
                        background: "#23416c",
                        display: publicType === "bus" ? "block" : "none",
                      },
                      color:
                        nearByUniversities?.length && publicType === "bus"
                          ? "#23416c"
                          : "#000000",
                    }}
                    onClick={() => getNearestLocations("bus")}
                  >
                    Bus Stations
                  </Button>

                  <Button
                    sx={{
                      minWidth: "max-content",
                      "&:before": {
                        content: '""',
                        borderTopRightRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        height: "2px",
                        background: "#23416c",
                        display: publicType === "train" ? "block" : "none",
                      },
                      color:
                        nearByUniversities?.length && publicType === "train"
                          ? "#23416c"
                          : "#000000",
                    }}
                    onClick={() => getNearestLocations("train")}
                  >
                    Train Stations
                  </Button>

                  <Button
                    sx={{
                      minWidth: "max-content",
                      "&:before": {
                        content: '""',
                        borderTopRightRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        height: "2px",
                        background: "#23416c",
                        display: publicType === "market" ? "block" : "none",
                      },
                      color:
                        nearByUniversities?.length && publicType === "market"
                          ? "#23416c"
                          : "#000000",
                    }}
                    onClick={() => getNearestLocations("market")}
                  >
                    Supermarkets
                  </Button>

                  <Button
                    sx={{
                      minWidth: "max-content",
                      "&:before": {
                        content: '""',
                        borderTopRightRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        height: "2px",
                        background: "#23416c",
                        display: publicType === "pharmacie" ? "block" : "none",
                      },
                      color:
                        nearByUniversities?.length && publicType === "pharmacie"
                          ? "#23416c"
                          : "#000000",
                    }}
                    onClick={() => getNearestLocations("pharmacie")}
                  >
                    Pharmacies
                  </Button>

                  <Button
                    sx={{
                      minWidth: "max-content",
                      "&:before": {
                        content: '""',
                        borderTopRightRadius: "1rem",
                        borderBottomRightRadius: "1rem",
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        height: "2px",
                        background: "#23416c",
                        display: publicType === "restaurant" ? "block" : "none",
                      },
                      color:
                        nearByUniversities?.length &&
                        publicType === "restaurant"
                          ? "#23416c"
                          : "#000000",
                    }}
                    onClick={() => getNearestLocations("restaurant")}
                  >
                    Restaurants
                  </Button>
                </Box> */}
                </Box>
              ) : null}

              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  margin: "0 24px 24px 0",
                  borderLeft: "1px solid #e9ecee",
                  paddingLeft: "24px",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // background: lightMode ? "#ffffff" : "#292929",
                    height: locations?.length ? "auto" : "100%",
                    position: "relative",
                  }}
                >
                  <>
                    <Locations moveToLocation={moveToLocation} />
                  </>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </>
    </ThemeProvider>
  ) : (
    <CircularProgress />
  );
}
